import { render, staticRenderFns } from "./swiperUser.vue?vue&type=template&id=dc20ec4e&scoped=true&"
import script from "./swiperUser.vue?vue&type=script&lang=js&"
export * from "./swiperUser.vue?vue&type=script&lang=js&"
import style0 from "./swiperUser.vue?vue&type=style&index=0&id=dc20ec4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc20ec4e",
  null
  
)

export default component.exports